import { StockRecommendations } from "./StockRecommendations";

export default StockRecommendations;
